import React from "react";
import styles from "./AllInfoContainer.module.scss";
import Title from "../../../../ui/Title/Title";
import { BitrixIcon } from "../../../../assets/icons/BitrixIcon";
import { LoadingComponent } from "../../../LoadingComponent/LoadingComponent";
import { ErrorComponent } from "../../../ErrorComponent/ErrorComponent";

export const AllInfoContainer = ({ activeBitrix, errorBitrix }) => {
  const DataItem = ({ title, data }) => {
    return (
      <div className={styles.dataItemContainer}>
        <label className={styles.title}>{title}</label>
        <label className={styles.data}>{data}</label>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {errorBitrix && (
        <ErrorComponent
          title={"Произошла ошибка при получении данных Bitrix"}
          text={
            "При получении данных о вашем аккаунте произошла ошибка. Вы можете вернуться на страницу интеграций и попробовать открыть страницу еще раз."
          }
          buttonTitle={"Вернуться на страницу интеграций"}
          path={"/integration"}
        />
      )}
      {activeBitrix && !errorBitrix ? (
        <>
          <div className={styles.header}>
            <div className={styles.headerInfoContainer}>
              <div className={styles.headerInfoContainerTitle}>
                <Title
                  title={`${activeBitrix?.dataUser?.name} ${activeBitrix?.dataUser.secondName} ${activeBitrix?.dataUser.lastName}`}
                  className={styles.title}
                />
                <BitrixIcon width={90} height={20} fill={"#3e8fcb"} />
              </div>
            </div>
          </div>

          {activeBitrix && !errorBitrix && (
            <>
              <div className={styles.rowData}>
                <DataItem
                  title={"Client id"}
                  data={activeBitrix?.dataUser.clientId}
                />
                <DataItem
                  title={"XML id"}
                  data={activeBitrix?.dataUser.xmlId}
                />
                <DataItem
                  title={"Bitrix id"}
                  data={activeBitrix?.dataUser.bitrixUserId}
                />
              </div>

              <div className={styles.rowData}>
                <DataItem title={"Почта"} data={activeBitrix?.dataUser.email} />
                <DataItem
                  title={"Api URL"}
                  data={activeBitrix?.dataUser.apiURL}
                />
              </div>
              <div className={styles.rowData}>
                <DataItem
                  title={"Персональный номер телефона"}
                  data={activeBitrix?.dataUser.personalMobile}
                />
                {activeBitrix?.dataUser.workPhone && (
                  <DataItem
                    title={"Рабочий номер телефона"}
                    data={activeBitrix?.dataUser.workPhone}
                  />
                )}
              </div>
            </>
          )}
        </>
      ) : (
        !errorBitrix && <LoadingComponent />
      )}
    </div>
  );
};
